<script lang="ts">
  import '../../../../app.postcss'

  import ArrowSvg from '../../components/SVGs/ArrowSVG.svelte'
  import ButaneImage from '$lib/components/ButaneImage.svelte'
  let faq_heading = '[ FOLLOW US ]'

  const followInfo = [
    {
      image: 'discord.png',
      name: 'Discord',
      content: 'Quickest response from our active community',
      link: 'https://discord.gg/pxJah7qnnu',
    },
    {
      image: 'twitter.png',
      name: 'X',
      content: 'Follow our latest updates and news on X',
      link: 'https://x.com/butaneprotocol',
    },
    {
      image: 'telegram.png',
      name: 'Telegram',
      content: 'Join our fastest growing social for daily tips',
      link: 'https://t.me/butaneprotocol',
    },
    {
      image: 'forum.png',
      name: 'Forum',
      content: 'Discover the paradise for developers',
      link: 'https://forum.butane.dev/',
    },
  ]
</script>

<section class="relative flex flex-col items-center space-y-14">
  <h2 class="w-fit font-cirka font-[12px] tracking-widest">{faq_heading}</h2>
  <ul class="m-2 grid grid-cols-[repeat(auto-fit,minmax(350px,1fr))] justify-items-center gap-4 px-2 lg:grid-cols-2">
    {#each followInfo as { image, name, content, link }}
      <li
        class="item flex w-full items-baseline justify-between border-t-[1px] border-[#323948] py-4 align-baseline lg:mx-20"
      >
        <div class="flex flex-col gap-y-6">
          <ButaneImage src={image} layout="fixed" width={66} height={66} alt="Social Logo" />
          <p class="text-[26px] lg:col-start-2 lg:row-start-1 lg:w-[308px]">{content}</p>
        </div>

        <a href={link} class="flex size-11 items-center justify-center" target="_blank" rel="noreferrer" aria-label={name}>
          <ArrowSvg fillStyles="white" svgStyles="scale-150" />
        </a>
      </li>
    {/each}
  </ul>
</section>

<style lang="postcss">
  @media (min-width: 1440px) {
    ul {
      gap: 0;
      width: 1320px;
    }

    li {
      width: 100%;
      gap: 12rem;
      justify-content: unset;
    }

    li div {
      flex-direction: row;
      column-gap: 2rem;
    }

    a {
      align-self: center;
    }
  }
</style>
